//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/mashroom/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/mashroom/partners' // @/configurations/content/partners-dark для темной темы

export default {
  pageTitle: 'Выбор между NGFW и WAF для комплексной стратегии защиты',
  logo: {
    image: require('@/assets/logo/T1 oblako main.png'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'Mashroom logo'
  },
  pageBackgroundImage: require('@/assets/background/background втб.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'Выбор между NGFW и WAF для комплексной стратегии защиты',
    description: [
      'В современном мире киберугрозы становятся всё более продуманными и частыми. Обеспечить надёжную защиту информационных систем, сетей и веб-приложений – это критически важная задача для любой организации. Среди множества средств и технологий для защиты сетей особое место занимают Web Application Firewall (WAF) и Next Generation Firewall (NGFW).',
      'На вебинаре Игорь Плотников, руководитель направления развития сервисов информационной безопасности T1 Облако, подробно рассмотрит особенности и преимущества каждого из этих сервисов, а также расскажет, какие задачи они могут решить, если их использовать вместе.',
      'Вы узнаете:',
      '<uh> <li>По каким ключевым параметрам можно сравнить преимущества NGFW и WAF</li> <li>Когда предпочтительнее использовать NGFW, а когда — WAF</li> <li>В каких случаях вашей компании подойдет решение с совместным применением NGFW и WAF</li> <li>Какие еще факторы следует учитывать для построения комплексной защиты периметра и веб-сервисов</li>',
      '',
      '',
      '',
      '',
      '',
      '',
      ''
    ],
    date: '29.10.2024',
    time: '11:00'
  },
  activities: [
    {
      tabName: 'Выберите', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'Ibjwdxhq',
          id: 3510,
          hallName: 'Основной шоурил' // название зала
        }
      ]
    }
  ],
  player: {
    title: 'Трансляция' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Расписание' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как добраться', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/image.jpg'), // путь до изображения для блока с картинкой
    items: [
      'Обычно мы сами приезжаем в гости, к вам в офис или на предполагаемую площадку, где будет происходить ваше мероприятие.',
      'Если у вас полностью виртуальное мероприятие, где вы и ваши гости подключаются удаленно, то проект удобно будет обсудить удаленно, на платформах Dion (для клиентов из РФ, которым важно использование отечественного ПО) или Zoom.',
      'Мы располагаем помещением-трансформером, где мы сможем провести очную и результативную рабочую встречу, продемонстрировать наши производственные возможности, работая с контентом на огромном экране.',
      '',
      '',
      '',
      'https://t1.ru/competencies/item/vychislitelnye-kompleksy/'
    ]
  },
  info: {
    title: 'О компании', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      '<a href="https://t1-cloud.ru" target="_blank">T1 Облако</a> – российский облачный провайдер, входит в многопрофильный холдинг T1.',
      'Мы помогаем компаниям разных отраслей и масштаба в оптимизации ИТ-инфраструктуры, обеспечении непрерывности бизнеса и ускорении процессов. Предоставляем комплексные решения с использованием публичных, частных и гибридных облаков. Нашим клиентам доступен широкий портфель облачных сервисов по моделям IaaS, PaaS, SaaS, а также стек импортонезависимых решений на базе отечественных технологий для выполнения широкого спектра задач любой сложности.',
      '<a href="https://t1-cloud.ru"><img style="margin-right:50px" src="assets/image-block/globe.png" </a><a href="https://t.me/+T2zK23rSV1w0OGIy"><img style="margin-right:50px" src="assets/image-block/telegram.png" </a> <a href="https://vk.com/t1_cloud"><img style="margin-right:50px" src="assets/image-block/vk-1.png" </a> <a href="https://www.youtube.com/@t1-cloud"><img style="margin-right:50px" src="assets/image-block/youtube-1.png" </a>',
      '<a href="https://t1-cloud.ru/news-subscribe?utm_source=landing&utm_medium=wecloudevents&utm_campaign=subscription_site&utm_content=webinar_database_9.03.2024" target="_blank">Подписка на рассылку</a>',
      'Почта: <a href="team@t1-cloud.ru" target="_blank">team@t1-cloud.ru</a>',
      '',
      '',
      ''
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Наши клиенты' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Т1 Облако,',
    phone: ''
  }
}
